import { env } from "../../../config/env";
import API_PATHS from "../../../config/api";
import { set, remove, STORAGE_KEYS } from "../../../lib/storage";
import { User } from "../../../types/user";

export const authService = {
  login: async (
    email: string,
    password: string
  ): Promise<{ account: User; jwt_token: string }> => {
    const loginBaseUrl = env.REACT_APP_FMCG_LOGIN || env.REACT_APP_API_URL;
    if (!loginBaseUrl) {
      throw new Error("Missing API base URL for login");
    }

    const normalizedBaseUrl = loginBaseUrl.endsWith("/")
      ? loginBaseUrl
      : `${loginBaseUrl}/`;
    const url = `${normalizedBaseUrl}${API_PATHS.LOGIN}`;
    const authHeaders = new Headers();
    authHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    authHeaders.append("x-growsari-app", "store");

    const urlencoded = new URLSearchParams();
    urlencoded.append("username", email);
    urlencoded.append("password", password);
    urlencoded.append("jwt_token", "true");

    const requestOptions = {
      method: "POST",
      headers: authHeaders,
      body: urlencoded,
      redirect: "follow" as const,
    };

    const request = await fetch(url, requestOptions);
    const response = await request.json();

    if (!response.jwt_token) {
      throw new Error(response.message || "Login failed");
    }

    return response;
  },

  googleLogin: async (
    idToken: string
  ): Promise<{ token: string; user: { email: string; username: string; role: string } }> => {
    const baseUrl = env.REACT_APP_API_URL;
    if (!baseUrl) {
      throw new Error("Missing API base URL for Google login");
    }

    const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
    const url = `${normalizedBaseUrl}${API_PATHS.GOOGLE_LOGIN}`;

    const request = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id_token: idToken }),
    });

    const response = await request.json();

    if (!response.success) {
      throw new Error(response.message || "Google login failed");
    }

    return response.data;
  },

  setAuthToken: (token: string): void => {
    set(STORAGE_KEYS.ACCESS_TOKEN, token);
  },

  clearAuthToken: (): void => {
    remove(STORAGE_KEYS.ACCESS_TOKEN);
  },

  isDevMode: (): boolean => {
    return env.REACT_APP_IS_DEV;
  },
};

export default authService;
